import { createContext, useContext } from 'react';

import { LiveEventAction } from 'types';

export type LiveEventContext = {
  channelName: string;
  eventCode: string;
  inviteeCode?: string;
  isPictureInPictureModeEnabled: boolean;
  enablePictureInPictureMode(request?: boolean): void;
  disablePictureInPictureMode(request?: boolean): void;
  openLoginPanel(attempt?: LiveEventAction): void;
  closePanel(): void;
};

export const defaultContextValue: LiveEventContext = {
  channelName: '',
  eventCode: '',
  inviteeCode: undefined,
  isPictureInPictureModeEnabled: false,
  enablePictureInPictureMode: () => {},
  disablePictureInPictureMode: () => {},
  openLoginPanel: () => {},
  closePanel: () => {}
};

export const liveEventContext = createContext<LiveEventContext>(defaultContextValue);

export const useLiveEvent = () => useContext(liveEventContext);
